import Actions from 'src/components/actionbar';
import styles from './styles.module.scss';
import { useRef } from 'react';

export const FavIconEditor = ({icon, onChange}: {icon: any, onChange: (value: File) => void}) => {
  
  console.log("icon in fav icon editor", icon);
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
         <h6 className={styles.title}>Favicon</h6>
         <p className={styles.subTitle}>Upload your brand icon to appear in browser tabs.</p>
      </div>

      <div className={styles.uploadContainer} onClick={() => inputRef.current?.click()}>
          <div className={styles.iconContainer}>
            {icon && <img className={styles.icon} src={icon} alt="Favicon Preview" />}
          </div> 
          <Actions.IconButton
              icon={"paperflite-edit"}
              className={styles.editIcon}
          />
      </div>

      <p className={styles.content}>Recommended dimensions: 16 × 16 pixels.</p>

      <input ref={inputRef} className={styles.hideFileInput} accept="image/png, image/jpeg, image/jpg, image/webp, image/svg+xml" type="file" onChange={(e: any) => {
        if(e.target.files[0]){
          onChange(e.target.files?.[0]);
        }
      }}/>
    </div>
  )
}